/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useEffect, useState } from 'react';
import {
  AnalyticsWidgetComp,
  Header,
  MapFilter,
  SettingsComp,
  // UsersListComp,
} from '../components';

import { vappContainer, VApplication } from '../../../application';

import {
  useSMmasqueraderReportContent,
  // useSMMapCardContent,
} from '../machines';
import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';
import { Paginate } from '@vlinder-web/paginate-widget-react';
import { SearchFilter } from '../../../widgets/filter-widget-react';
import { useNavigate } from 'react-router-dom';
import { GenericReportPageService } from '../services';
import { AppNavigatorService } from '@/AppNavigator';
import { Loader } from '@/components';

const getSrv = () => {
  return vappContainer.get<GenericReportPageService>(
    GenericReportPageService.displayName
  );
};

const getAppSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export const ContainerComm = (props: any) => {
  const staticPageContentConfig = getSrv()?.agent?.getStaticPageContentSync({});
  const {
    masqueraderReportSend,
    masqueraderReportState,
    masqueraderReportPageMachine,
  } = useSMmasqueraderReportContent({});
  const navigate = useNavigate();
  const [country, setCountry] = useState<any>('all');
  const [presentation, setPresentation] = useState<any>('');
  // const { MapCardPageMachine, MapCardSend, MapCardState } = useSMMapCardContent(
  //   {}
  // );
  const srv = getSrv();
  // useEffect(() => {
  //   srv?.resetCriteria();
  // }, []);

  const onClearFilter = () => {
    setCountry('all');
    // srv?.resetCriteria();
    let criteria = {};
    if (presentation) {
      criteria = {
        ...criteria,
        presentation: presentation,
      };
    }
    masqueraderReportSend('TRIGGER_REFRESH', {
      criteria: criteria,
    });
  };

  const _onClearFilter = () => {
    setCountry('all');
    // srv?.resetCriteria();
    setPresentation(undefined);
    masqueraderReportSend('TRIGGER_REFRESH', {});
    MapCardSend('TRIGGER_REFRESH', {});
  };

  const onApplyFilter = (data?: any, present?: any) => {
    console.log('title', data, present);
    setCountry(data);
    let criteria = {};
    if (data && data !== 'all') {
      criteria = {
        country: data,
      };
    }
    if (present || presentation) {
      criteria = {
        ...criteria,
        presentation: present ?? presentation,
      };
    }
    masqueraderReportSend('TRIGGER_REFRESH', {
      criteria: criteria,
    });
  };

  const _onApplyFilter = (data?: any, gender?: string) => {
    let criteria = {};
    criteria = {
      gender: gender,
      id: data,
    };
    setPresentation(data);
    onApplyFilter(country, data);
    MapCardSend('TRIGGER_REFRESH', {
      criteria: criteria,
    });
  };

  const onTogglePress = (
    key: string,
    item: { id: string; email: string; vuid: string }
  ) => {
    if (key === 'viewBoxDetails') {
      // history.push({
      //   pathname: routes?.ViewMasqBoxDetails?.path,
      //   state: {
      //     id: item?.id,
      //     prevPage: "GeoReport",
      //   },
      // });
    }
  };

  const _renderCountry = () => {
    return country;
  };
  const _renderHeader = () => {
    if (staticPageContentConfig?.header) {
      return (
        <>
          <Header {...(staticPageContentConfig?.header || {})} />
          {/* <MapFilter
            {...(MapCardState?.event?.data?.value || {})}
            {...(staticPageContentConfig?.genderConfig || {})}
            onApplyFilter={_onApplyFilter}
            onClearFilter={_onClearFilter}
          /> */}
        </>
      );
    }
    return null;
  };

  const renderfilter = () => {
    console.log('country', country);
    return (
      <>
        {/* <SettingsComp
          {...(masqueraderReportState?.event?.data?.value || {})}
          defaultLabel={country}
          onApplyFilter={onApplyFilter}
          onClearFilter={onClearFilter}
        /> */}
      </>
    );
  };

  const onPaginationChange = (event: any) => {
    masqueraderReportSend('TRIGGER_REFRESH', {
      offset: event?.selected * 10,
      size: 10,
    });
  };

  const _renderPagination = () => {
    console.log(
      'pagination in userlist===',
      masqueraderReportState?.event?.data?.value?.ultUsers?.length
    );
    return (
      <Paginate
        {...(masqueraderReportState?.event?.data?.value || {})}
        onPageChange={onPaginationChange}
        totalItems={
          masqueraderReportState?.event?.data?.value?.ultUsers?.length
        }
      />
    );
  };

  const _renderPage = () => {
    if (masqueraderReportState?.matches('GET_PAGE_CONTENT')) {
      console.log('GET_PAGE_CONTENT');
      return (
        <Loader
          {...(staticPageContentConfig?.loading?.overViewLoading || {})}
        />
      );
    }
    if (masqueraderReportState?.matches('RENDER_PAGE')) {
      console.log(
        'staticPageContentConfig?.analytics===>',
        masqueraderReportState?.event?.data?.value
      );
      return (
        <>
          {masqueraderReportState?.event?.data?.value?.isEmpty ? (
            <>
              {renderfilter()}
              <div>sa</div>
              <StateOSD
                {...(staticPageContentConfig?.loading?.usersEmpty || {})}
              />
            </>
          ) : (
            // <UsersListComp
            //   {...(masqueraderReportState?.event?.data?.value || {})}
            // />
            <>
              {renderfilter()}

              <AnalyticsWidgetComp
                onAppCardClick={(title?: any) => onApplyFilter(title)}
                hoverColor={'#E6E6FA'}
                backgroundColor={'#c294c3'}
                backgroundTitle={_renderCountry()}
                // highest={MapCardState?.event?.data?.value?.highest}
                {...(masqueraderReportState?.event?.data?.value || {})}
              />
              {/* <UsersListComp
                {...(masqueraderReportState?.event?.data?.value || {})}
                onTogglePress={onTogglePress}
              /> */}
            </>
          )}
        </>
      );
    }
    if (masqueraderReportState?.matches('RENDER_PAGE_ERROR')) {
      return <Loader {...(staticPageContentConfig?.loading?.errorMsg || {})} />;
    }
    return null;
  };

  // const _renderMap = () => {
  //   if (MapCardState?.matches("GET_PAGE_CONTENT")) {
  //     console.log(
  //       "GET_PAGE_CONTENT==>",
  //       staticPageContentConfig?.loading?.overViewLoading
  //     );
  //     return (
  //       <StateOSD
  //         {...(staticPageContentConfig?.loading?.overViewLoading || {})}
  //       />
  //     );
  //   }
  //   if (MapCardState?.matches("RENDER_PAGE")) {
  //     console.log(
  //       "MapCardState?.event?.data?.value?.map==>",
  //       MapCardState?.event?.data?.value
  //     );
  //     return (
  //       <>
  //         {MapCardState?.event?.data?.value?.isEmpty ? (
  //           <StateOSD
  //             {...(staticPageContentConfig?.loading?.usersEmpty || {})}
  //           />
  //         ) : (
  //           <AnalyticsWidgetComp
  //             onAppCardClick={(title?: any) => onApplyFilter(title)}
  //             hoverColor={"#E6E6FA"}
  //             backgroundColor={"#c294c3"}
  //             backgroundTitle={_renderCountry()}
  //             highest={MapCardState?.event?.data?.value?.highest}
  //             {...(MapCardState?.event?.data?.value?.map || {})}
  //           />
  //         )}
  //       </>
  //     );
  //   }
  //   if (MapCardState?.matches("RENDER_PAGE_ERROR")) {
  //     return (
  //       <StateOSD {...(staticPageContentConfig?.loading?.errorMsg || {})} />
  //     );
  //   }
  //   return null;
  // };
  return (
    <div>
      {_renderHeader()}
      {/* {_renderMap()} */}
      {_renderPage()}
      {/* {_renderPagination()} */}
    </div>
  );
};
